import { useState, useEffect } from "react";
import { useNavigate} from "react-router-dom";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const CollaborationRequests = ({owner}) => {
  const navigate = useNavigate();
  const [collaboration_requests, setCollaborationRequests] = useState([]);
  const [search, setSearch] = useState("");
  // console.log("The lab heads are:",collaboration_requests)
   const fetchCollaborationRequests = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/marketplace/industry/collaboration/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });
        setCollaborationRequests(res?.data || []);
      } catch (error) {
        console.log("Error while getting profiles", error);
        setCollaborationRequests([]);
      }
    };
  useEffect(() => {
    fetchCollaborationRequests();
  }, []);

  // Inline filtering
  const filteredDeans = collaboration_requests.filter(
    (dean) =>
      dean?.profile_data?.name?.toLowerCase().includes(search.toLowerCase()) ||
      dean?.profile_data?.email?.toLowerCase().includes(search.toLowerCase())
  );
const handleDelete = async (id) => {

    const confirmDelete = window.confirm("Are you sure you want to delete this manager?");
    
    if (!confirmDelete) {
        return; // Stop if user clicks Cancel
    }

    try {
        const res = await axios.delete(
            `${BASE_URL}/marketplace/industry/manager/${id}/`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "x-api-key": process.env.REACT_APP_X_API_KEY,
                },
            }
        );

        if (res.status === 204) {
            alert("Manager Deleted Successfully");
            fetchCollaborationRequests();
        }

    } catch (error) {
        console.log("Error while deleting dean", error);
    }
};

  return (
   <div className="p-6 max-w-7xl mx-auto">
  {/* Header */}
  <div className="flex items-center gap-3 mb-6">
    <div className="w-12 h-12 bg-[#e8f0f7] rounded-xl flex items-center justify-center">
      <svg className="w-6 h-6 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    </div>
    <div>
      <h1 className="text-2xl font-bold text-gray-900">Collaboration Requests</h1>
      <p className="text-sm text-gray-500 mt-1">
          Manage all incoming and outgoing collaboration requests.
      </p>
    </div>
  </div>

  {/* Search and Add Bar */}
 <div className="w-full flex flex-col sm:flex-row justify-between items-center mb-6 gap-4">
  
  {/* Search Input */}
  <div className="relative flex-1 w-full">
    <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
    </div>
    <input
      type="text"
      placeholder="Search by name or email..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl text-sm focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
    />
  </div>

  {/* Create Workspace Button */}
  {/* <button
    className="flex items-center gap-2 px-5 py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors"
  >
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 4v16m8-8H4"
      />
    </svg>
    Create Workspace
  </button> */}

</div>


  {/* Table */}
  <div className="border border-gray-200 rounded-xl overflow-x-auto">
    <table className="w-full">
      <thead className="bg-gray-50 border-b border-gray-200">
        <tr>
          <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Profile</th>
          <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Name</th>
          <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Email</th>
          <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">University</th>
          <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Role in University</th>
          <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">status</th>
          {/* <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Department</th>
          <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Lab</th> */}
          <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Actions</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
        {filteredDeans.map((dean) => (
          <tr key={dean.id} className="hover:bg-gray-50 transition-colors">
            <td className="px-6 py-4">
              <div className="relative w-10 h-10">
                <img
                  src={dean?.profile_data?.profile_picture}
                  alt={dean?.profile_data?.name}
                  className="w-10 h-10 rounded-xl object-cover border border-gray-200"
                />
                <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></div>
              </div>
            </td>
            <td className="px-6 py-4">
              <p className="text-sm font-medium text-gray-900">{dean?.profile_data?.name}</p>
            </td>
            <td className="px-6 py-4">
              <p className="text-sm text-gray-600">{dean?.profile_data?.email}</p>
            </td>
              <td className="px-6 py-4">
              <p className="text-sm text-gray-600">{dean?.university === null  ? '-' : dean?.university?.name}</p>
            </td>
              <td className="px-6 py-4">
              <p className="text-sm text-gray-600">{dean?.university?.role || "-"}</p>
            </td>
             <td className="px-6 py-4">
             <p className="text-sm text-gray-600 capitalize">{dean?.status === 'pending' ? "Pending" : dean?.status ==='accept' ? "Accepted" : "Rejected"}</p>
            </td>
            <td className="flex gap-4 px-6 py-4">
              <button
  onClick={() => navigate(owner ==='admin' ? `/marketplace/industry/collaboration-requests/${dean?.id}` : owner === 'manager' ? `/marketplace/industry/manager/collaboration-requests/${dean?.id}` : `/marketplace/industry/manager/assistant_manager/collaboration-requests/${dean?.id}`)}
  className="whitespace-nowrap flex items-center justify-center gap-2 px-5 py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors"
>
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    />
  </svg>
  View Details
</button>
    {
      dean?.status === 'accept' && 
      <button
  // onClick={() => navigate(`/marketplace/industry/collaboration-requests/${dean?.id}`)}
  className="whitespace-nowrap flex items-center justify-center gap-2 px-5 py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors"
>
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M7 8h10M7 12h6m-7 8l-4-4H4a2 2 0 01-2-2V6a2 2 0 012-2h16a2 2 0 012 2v8a2 2 0 01-2 2H9l-2 2z"
    />
  </svg>
  Chat
</button>
    }
    {
  dean?.status === "accept" && (
    <button
      onClick={() => navigate(owner ==='admin' ? `/marketplace/industry/workspaces/create-workspace/${dean?.id}` : owner ==='manager' ? `/marketplace/industry/manager/workspaces/create-workspace/${dean?.id}` : `/marketplace/industry/manager/assistant_manager/workspaces/create-workspace/${dean?.id}` ,{
        state:{profile_id:dean?.profile_data?.id}
      })}
      className="whitespace-nowrap flex items-center justify-center gap-2 px-5 py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors"
    >
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 4v16m8-8H4"
        />
      </svg>
      Create Workspace
    </button>
  )
}
            </td>
          </tr>
        ))}

        {filteredDeans.length === 0 && (
          <tr>
            <td colSpan={4} className="px-6 py-12 text-center">
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                </div>
                <p className="text-gray-500 font-medium">No collaboration requests found</p>
                {/* <p className="text-sm text-gray-400 mt-1">Add a manager to get started</p> */}
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</div>
  );
};

export default CollaborationRequests;
